import { PUBLIC_URIS } from '../constants/publicURIs.constants';
import Login from '../pages/auth/log-in';
import SignUp from '../pages/auth/sign-up';

const {
  LOGIN,
  SIGNUP,
  THE_MOTIVATION,
  THE_APP,
  REQUEST_DEMO,
  KNOWLEDGE_BASE,
  LEADERSHIP_AND_INVESTORS,
  TEAM,
  CAREERS,
  NEWSROOM,
  CONTACT_US,
  TERMS_OF_USE,
  PRIVACY_POLICY,
  SECURITY,
} = PUBLIC_URIS;

export const PUBLIC_ROUTES = [
  {
    name: 'User Login',
    uri: LOGIN,
    Component: Login,
  },
  {
    name: 'Sign up',
    uri: SIGNUP,
    Component: SignUp,
  },
];
